import { createApp } from 'vue' 
import App from './App.vue' 
import { createHead } from '@vueuse/head' 
import 'bootstrap/dist/css/bootstrap-grid.min.css' 
import 'bootstrap-vue/dist/bootstrap-vue.css' 
import store from './assets/js/store.js'; 
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; 
 import router from './router'
  const head = createHead() 
  createApp(App).use(head).use(store).use(router).mount('#app')